import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainBlock } from './components/PainBlock';
import { AgitationSection } from './components/AgitationSection';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForWhoSection } from './components/ForWhoSection';
import { Testimonials } from './components/Testimonials';
import { GuaranteeBlock } from './components/GuaranteeBlock';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-bg font-sans selection:bg-brand-accent/30" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainBlock data-id="element-4" />
        <AgitationSection data-id="element-5" />
        <UniqueMechanism data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <ForWhoSection data-id="element-8" />
        <Testimonials data-id="element-9" />
        <GuaranteeBlock data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}